var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewExcelIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 10,
    fill: "#F3F9F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1774 13.231H30.1481V10.3965L10.375 13.4484V40.1992L30.1481 43.6049V39.4035H42.1774C42.5419 39.4226 42.8991 39.2963 43.1705 39.0523C43.4419 38.8083 43.6054 38.4665 43.625 38.102V14.5314C43.6051 14.1671 43.4415 13.8257 43.1701 13.5819C42.8987 13.3381 42.5417 13.2119 42.1774 13.231ZM42.3674 38.3182H30.1077L30.0875 36.075H33.0408V33.4625H30.0649L30.0507 31.9187H33.0408V29.3062H30.0281L30.0139 27.7625H33.0408V25.15H30.0044V23.6062H33.0408V20.9937H30.0044V19.45H33.0408V16.8375H30.0044V14.4625H42.3674V38.3182Z",
    fill: "#20744A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7033 16.834H39.8369V19.4465H34.7033V16.834ZM34.7033 20.9914H39.8369V23.6039H34.7033V20.9914ZM34.7033 25.1489H39.8369V27.7614H34.7033V25.1489ZM34.7033 29.3063H39.8369V31.9188H34.7033V29.3063ZM34.7033 33.4637H39.8369V36.0762H34.7033V33.4637Z",
    fill: "#20744A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.537 20.674L18.0854 20.5279L19.6874 24.9324L21.5802 20.3463L24.1286 20.2002L21.034 26.4536L24.1286 32.7224L21.4342 32.5407L19.6149 27.7622L17.7945 32.359L15.3185 32.1405L18.1947 26.6032L15.537 20.674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewExcelIcon);
export default __webpack_public_path__ + "static/media/new-excel-icon.431e8e8b87083675c51d8d7543490452.svg";
export { ForwardRef as ReactComponent };